<div class="d-flex justify-content-start user-info-component-wrapper">
    <div class="user-picture-container">
        <img
            alt="User picture"
            class="user-picture"
            [src]="
                userInfo?.profilePicture
                    ? userInfo?.profilePicture
                    : 'assets/svg/profile.svg'
            "
        />
    </div>
    <div class="user-text-container d-flex flex-column justify-content-between">
        <p class="name-info">
            {{ getDisplayName() }}
        </p>
        <p class="other-info">
            {{ getTranslationKeyForRole() | translate }}
        </p>
    </div>
</div>
